// extracted by mini-css-extract-plugin
export var container = "_kb-0";
export var outlet = "_kb-1";
export var outletEnter = "_kb-2";
export var outletEnterActive = "_kb-3";
export var outletExit = "_kb-4";
export var outletExitActive = "_kb-5";